import { Component, OnInit } from '@angular/core';
import { INotification, NotificationService,  } from '@core/services/notification';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification',
  imports: [CommonModule],
  templateUrl: './notification.html',
  styleUrl: './notification.scss'
})
export class Notification implements OnInit {
  notification: INotification | null = null;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService.notification$.subscribe((notif) => {
      this.notification = notif;
    });
  }
   close() {
    this.notificationService.clear(); 
  }
}